import React from 'react';
import aboutheader from '../../assets/images/about-header.webp';
import Heading from '../Headers/Heading';
import Art from '../Misc/Art';
import illustration from '../../assets/images/art_1.png';

function GetInvolvedHeader() {
    return (
        <>
            <div className="page-header position-relative">
                <Heading 
                    heading={<h1>Admissions & Intake</h1>}
                    headingClass="heading-very-large dark-1"
                    paragraph="Admissions at Dr. Mohammed Audu Rehab Centre are handled with confidentiality, professionalism, and respect for each individual’s circumstances."
                    paragraphClass="dark-2"
                    WrapperComponent={(props) => {
                        return (
                            <div className="page-header-top">
                                <div className="container">
                                    {props.children}
                                </div>
                            </div>
                        )
                    }}
                />
                <div className="page-header-bottom">
                    <div className="single-image">
                        <img src={aboutheader} alt="about-header" />
                    </div>
                </div>
                <Art art={illustration} type="1" />
            </div>
        </>
    );
}

export default GetInvolvedHeader; 
